<div [permissionArea]="'planning.attachment.read'">
	@if (attachmentNotice$ | async; as attachmentResponse) {
		@if (attachmentResponse.id || demand.isOriginalDemand || onlyComplementary) {
			@if (!demand.isOriginalDemand && !onlyComplementary) {
				<h4 class="fw-600 text-indigo mt-5 ms-3">Edital</h4>

				<ul class="list-group list-group-flush">
					<li class="list-group-item p-3 bg-white">
						<div class="d-flex justify-content-between align-items-center">
							@if (demand.publishStatusDone) {
								<div>
									<button class="btn btn-sm btn-outline-primary rounded-xl text-uppercase fw-600" (click)="openExternalLinkNoticePncp()">
										<fa-icon icon="external-link" class="me-2"></fa-icon>
										Abrir link no PNCP
									</button>

									@if (demand.noticeSession.statusCreated || demand.noticeSession.statusClosed) {
										<button class="btn btn-sm btn-link text-danger fw-600 ms-2" [disabled]="demand.deleting" (click)="cancel(demand)">
											<app-label-loading-dots [loading]="demand.deleting" label="Cancelar publicação"></app-label-loading-dots>
										</button>
									}
								</div>
							} @else {
								<button *permissions="'planning.attachment.create'" class="btn btn-sm btn-info rounded-xl text-uppercase fw-600" (click)="publishLoose()" [disabled]="submitted">
									{{ submitted ? 'Publicando no PNCP, aguarde...' : 'Publicar edital no PNCP' }}
								</button>
							}

							<button class="btn btn-sm btn-outline-primary rounded-xl border-0 fw-700" (click)="attachmentNoticeDownload()">
								<fa-icon icon="file-contract" class="me-2"></fa-icon>
								Visualizar ou alterar Documento
							</button>
						</div>
					</li>
				</ul>
			}

			<h4 class="fw-600 text-indigo mt-3 ms-3 mb-3">Complementares</h4>

			<ul class="list-group list-group-flush">
				<li class="list-group-item bg-white p-3 border-bottom-1">
					<div class="d-flex justify-content-between align-items-center">
						<small class="text-muted">
							Total de
							<b>{{ attachmentTotal ?? 0 | number }}</b>
							anexo(s)
						</small>
						<div>
							<button class="btn btn-sm btn-icon" (click)="fetchDemandAttachments()">
								<fa-icon icon="refresh"></fa-icon>
							</button>
							<button *permissions="'planning.attachment.create'" class="btn btn-sm btn-icon btn-primary ms-3" (click)="modalFormAttachment()">
								<fa-icon icon="plus"></fa-icon>
							</button>
						</div>
					</div>
				</li>
				@if (demandAttachments$ | async; as attachments) {
					@for (attachment of attachments; track attachment.id) {
						<li class="list-group-item p-3 border-bottom-1 bg-white">
							<div class="d-flex justify-content-between align-items-center">
								<div class="d-flex justify-content-between align-items-center">
									<div class="text-start ps-2" style="width: 57px">
										<small class="fw-600 text-dark">{{ attachment.ordering }}</small>
									</div>
									<div>
										<p class="text-uppercase fw-600 text-dark mb-0">
											{{ attachment.description }}
										</p>
										<small class="text-muted">{{ attachment.created | date: 'dd/MM/yyyy' }}</small>
										<app-file-size-badge [bytes]="attachment.metadata?.size"></app-file-size-badge>
										@if (
											(attachment.status === DemandIntentDocumentAttachmentStatus.PUBLISHED && demand.publishStatusDone) ||
											(attachment.status === DemandIntentDocumentAttachmentStatus.PUBLISHED && demand.publishStatusDone && !demand.loose)
											) {
											<small class="badge badge-sm text-bg-success fw-700 text-sm rounded-xl ms-2">Publicado</small>
										}
									</div>
								</div>
								@if (attachment.submitting || attachment.deleting || attachment.submitted) {
									<div class="d-flex justify-content-center">
										<app-pre-loading [inline]="true" [large]="false" [showMessage]="false"></app-pre-loading>
									</div>
								} @else {
									<div class="dropdown no-caret" ngbDropdown container="body">
										<a class="btn btn-sm btn-icon dropdown-toggle" ngbDropdownToggle role="button" aria-haspopup="true" aria-expanded="false">
											<fa-icon icon="ellipsis-vertical"></fa-icon>
										</a>

										<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu>
											<small class="dropdown-item fw-700">Ações do anexo</small>

											<button class="dropdown-item" (click)="attachmentDownload(attachment)">
												<div class="dropdown-item-icon">
													<i-feather name="download"></i-feather>
												</div>
												Baixar
											</button>

											@if (attachment?.latestSignature) {
												<button *permissions="'planning.attachment.create'"
													class="dropdown-item"
													[disabled]="documentEditorLoading || attachment.submitted"
													(click)="delegateAttachmentSignatures(attachment, true)">
													<div class="dropdown-item-icon"><fa-icon icon="file-signature"></fa-icon></div>
													<app-label-loading-dots [loading]="documentEditorLoading" label="Signatários"></app-label-loading-dots>
												</button>

												@if (attachment?.latestSignature?.status === DocumentSignatureStatus.DONE) {
													<button *permissions="'planning.electronic-process.update'"
														class="dropdown-item"
														[disabled]="attachment.submitted"
														(click)="addAttachmentElectronicProcesses(attachment)">
														<div class="dropdown-item-icon"><fa-icon icon="folder-plus"></fa-icon></div>
														<app-label-loading-dots
															[loading]="attachment.submitted"
															label="Incluir no Processo Eletrônico"></app-label-loading-dots>
													</button>
												}
											} @else {
												<button *permissions="'planning.attachment.create'"
													class="dropdown-item"
													[disabled]="documentEditorLoading || attachment.submitted"
													(click)="delegateAttachmentSignatures(attachment)">
													<div class="dropdown-item-icon"><fa-icon icon="file-signature"></fa-icon></div>
													<app-label-loading-dots [loading]="documentEditorLoading" label="Solicitar Assinatura"></app-label-loading-dots>
												</button>
											}

											@if (
												(attachment.status !== DemandIntentDocumentAttachmentStatus.PUBLISHED && demand.publishStatusDone) ||
												(attachment.status !== DemandIntentDocumentAttachmentStatus.PUBLISHED && demand.publishStatusDone && !demand.loose)
											) {
												<button *permissions="'planning.attachment.create'"
													class="dropdown-item text-info"
													(click)="publishLooseAttachmentOther(attachment)"
													[disabled]="attachment.submitted">
													<div class="dropdown-item-icon">
														<i-feather name="upload-cloud"></i-feather>
													</div>
													<app-label-loading-dots [loading]="attachment.submitted" label="Publicar" loadingLabel="Publicando, aguarde"></app-label-loading-dots>
												</button>
											}

											<div class="dropdown-divider"></div>

											<button *permissions="'planning.attachment.delete'" class="dropdown-item text-danger" [disabled]="attachment.deleting" (click)="removeAttachment(attachment)">
												<div class="dropdown-item-icon">
													@if (attachment.deleting) {
														<app-pre-loading [inline]="true" [large]="false" [showMessage]="false"></app-pre-loading>
													} @else {
														<i-feather name="trash-2"></i-feather>
													}
												</div>
												Remover
											</button>
										</div>
									</div>
								}
							</div>
						</li>
					}
				} @else {
					<div class="d-flex w-100 flex-column align-content-center overflow-hidden p-4">
						<app-placeholder-glow [loop]="4" [enableButton]="false"></app-placeholder-glow>
					</div>
				}
			</ul>
		} @else {
			@if (submittedAttachmentLoading) {
				<div class="w-100 d-flex align-items-center justify-content-center">
					<app-pre-loading msg="Enviado o anexo, aguarde"></app-pre-loading>
				</div>
			} @else {
				<div class="w-100 d-flex align-items-center justify-content-center" style="height: 50vh">
					<app-empty-data message="Antes de continuarmos, vamos iniciar incluindo o Anexo para a publicação no PNCP">
						<div class="w-100 d-flex justify-content-center pt-3">
							<input
								type="file"
								#fileAttachment
								(change)="attachmentNotice($event, demand.id, afterAttachmentNoticeUpdateStatusToOpened.bind(this))"
								style="display: none" />
							<button *permissions="'planning.attachment.create'" class="btn btn-sm btn-primary fw-600 text-uppercase" (click)="fileAttachment.click()">Clique aqui para começar</button>
						</div>
					</app-empty-data>
				</div>
			}
		}
	} @else {
		<div class="d-flex align-items-center justify-content-center" style="{{ !onlyComplementary ? 'height: 50vh' : '' }}">
			<app-pre-loading msg="Buscando anexos, aguarde"></app-pre-loading>
		</div>
	}

	<!--Modal view document-->
	<ng-template #modalAttachmentView let-modal>
		<div class="modal-header">
			<h4 class="modal-title">{{ attachmentTitle ?? 'Anexo' }}</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body m-0 p-0 overflow-y-hidden">
			@if (attachmentLoading) {
				<div class="d-flex h-100 align-items-center justify-content-center">
					<app-pre-loading></app-pre-loading>
				</div>
			} @else {
				<div class="d-flex h-100 justify-content-between">
					@if (attachmentMenuActions) {
						<div class="col-2">
							<div class="d-flex justify-content-end align-items-center w-100 flex-column">
								<div class="d-flex gap-2 w-100 flex-column mt-3">
									@if (
										(noticeAttachment && (demand.statusStarted || demand.statusCanceled || (!demand.isOriginalDemand && demand.isDispute))) ||
										(blockSignatureRequest && fallbackNoticeUrl)
									) {
										<input
											type="file"
											#fileAttachment
											(change)="attachmentNotice($event, demand.id, afterAttachmentNoticeUpdateStatusToOpenedReload.bind(this))"
											style="display: none" />
										<button *permissions="'planning.attachment.create'"
											class="btn btn-link ps-4 d-flex justify-content-start"
											[disabled]="submittedAttachmentLoading"
											(click)="fileAttachment.click()">
											<div class="pe-2">
												<fa-icon icon="file-edit"></fa-icon>
											</div>
											<b>Alterar Edital</b>
											@if (submittedAttachmentLoading) {
												<app-pre-loading [inline]="true" [showMessage]="false" [large]="false" class="ms-2"></app-pre-loading>
											}
										</button>
									}

									@if (demand?.latestSignature) {
										<button *permissions="'planning.attachment.create'"
											class="btn btn-link ps-4 d-flex justify-content-start"
											[disabled]="demand.submitted || blockSignatureRequest"
											(click)="delegateDocumentSignatures(demand, true)">
											<div class="pe-2">
												<fa-icon icon="file-signature"></fa-icon>
											</div>
											<b><app-label-loading-dots [loading]="demand.submitted" label="Signatários"></app-label-loading-dots></b>
										</button>

										@if (demand?.latestSignature?.status === DocumentSignatureStatus.DONE) {
											<button *permissions="'planning.electronic-process.update'"
												class="btn btn-link ps-4 d-flex justify-content-start"
												[disabled]="demand.submitted"
												(click)="addDocumentElectronicProcesses(demand)">
												<div class="pe-2">
													<fa-icon icon="folder-plus"></fa-icon>
												</div>
												<b>
													<app-label-loading-dots
														[loading]="demand.submitted"
														label="Incluir no Processo Eletrônico"></app-label-loading-dots>
												</b>
											</button>
										}
									} @else {
										<button *permissions="'planning.attachment.create'"
											class="btn btn-link ps-4 d-flex justify-content-start"
											[disabled]="demand.submitted || blockSignatureRequest"
											(click)="delegateDocumentSignatures(demand)">
											<div class="pe-2">
												<fa-icon icon="file-signature"></fa-icon>
											</div>
											<b><app-label-loading-dots [loading]="demand.submitted" label="Solicitar Assinatura"></app-label-loading-dots></b>
										</button>
									}

									@if (blockSignatureRequest && fallbackNoticeUrl) {
										<a
											class="btn btn-link ps-4 d-flex justify-content-start"
											[href]="fallbackNoticeUrl"
											target="_blank"
											rel="noopener noreferrer">
											<div class="pe-2">
												<fa-icon icon="external-link-alt"></fa-icon>
											</div>
											<b>Abrir edital manualmente (baixar)</b>
										</a>
									}
								</div>
							</div>
						</div>
					}
					<div [class.col-10]="attachmentMenuActions" [class.col-12]="!attachmentMenuActions">
						@if (attachmentUrl) {
							@if (attachmentUrl === 'error') {
								<div class="d-flex h-100 align-items-center justify-content-center">
									<app-empty-data
										[message]="
											fallbackNoticeUrl && blockSignatureRequest
												? 'Tívemos um problema interno, baixe o edital e clique em Alterar Edital caso deseje Solicitar Assinatura'
												: 'Não foi possível baixar o documento...'
										"></app-empty-data>
								</div>
							} @else {
								<iframe [src]="attachmentUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
							}
						}
					</div>
				</div>
			}
		</div>
	</ng-template>

	<!--Modal view attachment-->
	<ng-template #modalAttachment let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Anexo</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body m-0 p-0 overflow-y-hidden">
			@if (attachmentLoading) {
				<div class="d-flex h-100 align-items-center justify-content-center">
					<app-pre-loading></app-pre-loading>
				</div>
			} @else {
				@if (attachmentUrl) {
					@if (attachmentUrl === 'error') {
						<div class="d-flex h-100 align-items-center justify-content-center">
							<app-empty-data message="Não foi possível baixar o documento..."></app-empty-data>
						</div>
					} @else {
						<iframe [src]="attachmentUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
					}
				}
			}
		</div>
	</ng-template>

	<!--Modal add attachment-->
	<ng-template #modalAddAttachment let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Adicionar documento complementar</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body p-3" [formGroup]="formAttachment">
			<div class="row">
				<div class="col-md-12 mb-3">
					<div class="form-floating">
						<input
							class="form-control"
							type="text"
							appTextLimited
							[limited]="150"
							id="description"
							placeholder="Descrição"
							formControlName="description"
							[class.is-invalid]="descriptionAttachmentControlInvalid" />
						<label for="description">Descrição</label>
						@if (descriptionAttachmentControl.hasError('required')) {
							<div class="invalid-feedback">Informe a descrição</div>
						}
					</div>
				</div>

				<div class="col-md-12 mb-3">
					<label for="file" class="form-label">Anexe o documento em PDF</label>
					<input
						class="form-control form-control-lg"
						[class.is-invalid]="fileAttachmentControlInvalid"
						(change)="onAttachmentSelected($event)"
						id="file"
						type="file"
						[disabled]="submittedAttachment" />
					@if (fileAttachmentControl.hasError('required')) {
						<div class="invalid-feedback">Informe o anexo</div>
					}
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button class="btn btn-link me-2" (click)="modal.dismiss()">
				<fa-icon icon="reply" class="me-2"></fa-icon>
				Voltar
			</button>

			<button *permissions="'planning.attachment.create'" class="btn btn-primary" (click)="saveAttachment()" [disabled]="submittedAttachment">
				<app-label-loading-dots [loading]="submittedAttachment" label="Salvar"></app-label-loading-dots>
			</button>
		</div>
	</ng-template>

	<!--Modal Electronic Process-->
	<ng-template #modalElectronicProcess let-modal>
		<div class="modal-header">
			<h4 class="modal-title">PROCESSO ELETRÔNICO</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body p-0">
			<app-electronic-process-form
				[includeDocument]="includeDocumentMode"
				[includeDocumentRequest]="includeDocumentRequest"
				(processSaved)="onElectronicProcessSaved($event)"
				(processActionCompleted)="onElectronicProcessActionCompleted()"></app-electronic-process-form>
		</div>
	</ng-template>

	<app-form-signer
		#formSignerComponent
		[override]="true"
		[sourceIds]="sourceIds"
		[documentSignatures]="documentSignatures"
		[allowRemoveItems]="allowRemoveSignatureItems"
		(canceled)="confirmDocumentSignaturesCanceled()"
		(confirmed)="confirmDocumentSignaturesConfirmed()"
		(statusUpdated)="confirmDocumentSignaturesStatusUpdated($event)"></app-form-signer>
</div>
